var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{fullscreen: _vm.fullscreen},attrs:{"id":"app"}},[_c('navbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkAuth()),expression:"checkAuth()"}]}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }